import Image from "next/image";

export default function ImageFill({ src, priority, ...rest }) {
  return (
    <div className="next-image-wrapper">
      <Image
        layout="fill"
        objectFit={!rest?.objectFit && "cover"}
        unoptimized
        src={src}
        quality={100}
        priority={priority}
        alt={rest?.alt || rest?.alternativeText || ""}
        title={ !rest?.title && rest?.alt || !rest?.title && rest?.alternativeText || rest?.title || ""}
      />
    </div>
  );
}
